import { Directive, ElementRef, Input, NgZone, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appScrollToBottom]',
  standalone: true
})
export class ScrollToBottomDirective {

  constructor(private _el: ElementRef, private ngZone: NgZone) { }


  private resizeObserver: ResizeObserver | null = null;

  @Input() messageList: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['messageList'] && changes['messageList'].currentValue) {
      this.scrollToBottom();
    }
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  ngOnInit() {
    this.resizeObserver = new ResizeObserver(() => {
      this.ngZone.run(() => {
        this.scrollToBottom();
      });
    });

    this.resizeObserver.observe(this._el.nativeElement);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  public scrollToBottom() {
    try {
      const element = this._el.nativeElement;
      setTimeout(() => {
        element.scrollTo({
          top: element.scrollHeight,
          behavior: 'smooth'
        });
      }, 10);
    } catch (err) {
      console.error('scrollToBottom error', err);
    }
  }

}
